export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
} as const;

/**
 * HTTP credentials mode for fetch requests
 * Controls how cookies and authentication headers are sent with requests
 */
export const HTTP_CREDENTIALS_MODE = {
  SAME_ORIGIN: 'same-origin',
  INCLUDE: 'include',
  OMIT: 'omit',
} as const;

/**
 * HTTP cache mode for fetch requests
 * Controls how the request interacts with the browser's HTTP cache
 */
export const HTTP_CACHE_MODE = {
  NO_STORE: 'no-store',
  RELOAD: 'reload',
  NO_CACHE: 'no-cache',
  FORCE_CACHE: 'force-cache',
  ONLY_IF_CACHED: 'only-if-cached',
  DEFAULT: 'default',
} as const;

/**
 * HTTP Content-Type header values
 * Common MIME types for request/response bodies
 */
export const HTTP_CONTENT_TYPE = {
  JSON: 'application/json',
  FORM_URLENCODED: 'application/x-www-form-urlencoded',
  FORM_DATA: 'multipart/form-data',
  TEXT_PLAIN: 'text/plain',
  TEXT_HTML: 'text/html',
} as const;

/**
 * HTTP status codes
 * Standard HTTP response status codes used for response handling
 */
export const HTTP_STATUS_CODE = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  TEMPORARY_REDIRECT: 307,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_CONTENT: 422,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  CONFLICT: 409,
  PERMANENT_REDIRECT: 308,
} as const;
